<template>
  <SrpModal v-model:isVisible="_isVisible">
    <template #content>
      <!-- Move to group form -->
      <div class="move-ro-group-form">
        <div
          :class="{
            'standard-page-header': true,
            'standard-page-header--small-bottom-padding': true,
            'move-ro-group-form__header': true,
          }"
        >
          <h1 class="global-h1 standard-page-header__title">Move {{ props.photoIds.length > 1 ? `all ${props.photoIds.length} photos` : "1 photo" }} to</h1>
        </div>

        <ul class="move-ro-group-form__groups-list">
          <li
            :class="{
              'move-ro-group-form__group-radio-button-wrap': true,
              'move-ro-group-form__group-radio-button-wrap--with-bottom-divider': true,
            }"
          >
            <SrpCheckbox class="move-ro-group-form__group-radio-button" size="medium">
              <template #input><input type="radio" name="group" :value="''" v-model="selectedGroupId" /></template>
              <template #text><b>A new group</b></template>
            </SrpCheckbox>
          </li>

          <li class="move-ro-group-form__group-radio-button-wrap" v-for="group in props.allGroups" :key="group.id">
            <SrpCheckbox class="move-ro-group-form__group-radio-button" size="medium">
              <template #input><input type="radio" name="group" :value="group.id" v-model="selectedGroupId" /></template>
              <template #text>{{ group.name }}</template>
            </SrpCheckbox>
          </li>
        </ul>
      </div>
      <!-- / Move to group form -->
    </template>

    <template #footer="{ closeModal }">
      <SrpButton color="gray" fill="outlined" style="margin-right: 12px" @click="closeModal" :isDisabled="isMoving">Cancel</SrpButton>

      <SrpButton
        @click="
          async () => {
            await handleMoving();
            closeModal();
          }
        "
        :isDisabled="isMoving || selectedGroupId === null"
      >
        <template #icon>
          <LoadingIcon v-if="isMoving" :size="22" />
          <IconEmbedded v-else name="arrow-corner-top-right_2-5" :size="20" color="rgba(255, 255, 255, 0.4)" />
        </template>
        Move
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import PhotoGalleryV2Repo from "@repos/PhotoGalleryV2Repo";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import SrpCheckbox from "@components/ui/SrpCheckbox.vue";

const props = withDefaults(
  defineProps<{
    photoIds: Array<string>;
    customerId: string;
    allGroups: Array<{ name: string; id: string }>;
  }>(),
  {
    photoIds: () => [],
    customerId: "",
    allGroups: () => [],
  }
);

const emit = defineEmits<{
  (e: "completeMoving"): void;
}>();

// Selected group =============================================================
const selectedGroupId = ref<string | null>(null);

// Private isVisible ==========================================================
const _isVisible = ref<boolean>(false);

// Handle moving ==============================================================
const isMoving = ref<boolean>(false);

async function handleMoving() {
  isMoving.value = true;

  await PhotoGalleryV2Repo.movePhotosToAGallery(props.customerId, props.photoIds, selectedGroupId.value);
  emit("completeMoving");

  isMoving.value = false;
}
</script>

<style scoped lang="scss">
// Move to group form =========================================================
.move-ro-group-form {
  &__header {
    margin-bottom: 30px;
  }

  &__groups-list {
    gap: 11px;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    list-style: none;
  }

  &__group-radio-button-wrap {
    &--with-bottom-divider {
      padding-bottom: 20px;
      margin-bottom: 10px;
      border-bottom: 1px rgba(0, 0, 0, 0.15) dashed;
    }
  }

  &__group-radio-button {
  }
}
</style>
